export const DOCUMENT_STATE_EDIT = 'EDIT';
export const DOCUMENT_STATE_ADD = 'ADD';
export const DOCUMENT_STATE_REMOVE = 'REMOVE';
export const DOCUMENT_STATE_RESTORE = 'RESTORE';
export const DOCUMENT_STATE_NORMAL = 'NORMAL';
